import { render, staticRenderFns } from "./RedirectAlert.vue?vue&type=template&id=2c09557f&"
import script from "./RedirectAlert.vue?vue&type=script&lang=js&"
export * from "./RedirectAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports